import { defineMessages } from 'react-intl';

export default defineMessages({
    loanDetailsLabel: {
        id: '_.funding_progess_indicator.label.loan_details',
        defaultMessage: 'Loan details'
    },
    selectAmountLabel: {
        id: '_.funding_progess_indicator.label.select_amount',
        defaultMessage: 'Select amount'
    },
    finalChecksLabel: {
        id: '_.funding_progess_indicator.label.final_checks',
        defaultMessage: 'Final checks'
    },
    withdrawFundsLabel: {
        id: '_.funding_progess_indicator.label.withdraw_funds',
        defaultMessage: 'Withdraw funds'
    }
});
